import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { UserService } from 'src/app/angularJS/services/user/user.service';
import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';
import { ToolbarController } from 'src/app/angularJS/layout/toolbar/toolbar.controller';

/**
* A Controller used for the selection of a scheme to be used across the application
*/
export class SchemeController {
  public static $inject = [
    '$translate',
    'ACTToolbarService',
    'userService',
    'UserMessages',
    '$state'
  ];

  public schemes: Array<InterACT.Interfaces.Schemes.Scheme>;
  public currentLocale: string;

  constructor(
    private $translate: ng.translate.ITranslateService,
    private ActToolbarService: ACTToolbarService,
    private userService: UserService,
    private UserMessages: UserMessagesService,
    private $state: ng.ui.IStateService) {
    this.activate();
  }

  /**
   * Gets the translatable string to be used adjacent to the md-switch on a scheme card
   * @param active the state of the scheme
   * @returns the translatable string
   */
  public getActiveTranslatable = (active: boolean) => {
    return active ? 'STATUSES.ACTIVE' : 'STATUSES.NOT_ACTIVE';
  }

  /**
   * A method which sets a passed in scheme as the active scheme for InterACT
   * @param schemeToSet The scheme which we wish to set as the active scheme for InterACT
   */
  public toggleSchemeSelection = (schemeToSet: InterACT.Interfaces.Schemes.Scheme) => {
    const scheme = angular.copy(schemeToSet);
    delete (<any>scheme).active;

    if ((<any>schemeToSet).active) {
      this.userService.addSelectedScheme(scheme);
    } else {
      this.userService.removeSelectedScheme(scheme);
    }

    this.UserMessages.showToast(
      (<any>schemeToSet).active ? 'SCHEME_ACTIVE' : 'SCHEME_INACTIVE',
      { name: schemeToSet.name[this.currentLocale] }
    );
  }

  /**
   * Determines whether the entered scheme is the last selected scheme
   * and so must not be allowed to be deactivated.
   * @param scheme the scheme to check is active
   * @returns true if there is only one selected scheme and the entered scheme is active
   */
  public isLastSelectedScheme(scheme: InterACT.Interfaces.Schemes.Scheme) {
    return this.userService.selectedSchemes.length === 1 && (<any>scheme).active;
  }

  public goToSchemeEdit(scheme: InterACT.Interfaces.Schemes.Scheme) {
    this.$state.go('userSchemes-edit', {
      schemeId: scheme.id,
      scheme: scheme
    });
  }

  /**
   * Activated the controller
   */
  private activate() {
    this.ActToolbarService.getToolbar('primary').then((toolbar: ToolbarController) => {
      toolbar.setTitle('HEADING.SCHEMES');
    });
    this.currentLocale = this.$translate.use();
    this.schemes = this.userService.schemes;
    this.setSelectedSchemes();
  }

  /**
   * A method which is used to set the selected schemes on activation
   */
  private setSelectedSchemes() {
    this.schemes.forEach((scheme) => {
      const existingScheme = _.find(this.userService.selectedSchemes, (selectedScheme) => {
        return selectedScheme.id === scheme.id;
      });
      if (existingScheme) {
        (<any>scheme).active = true;
      } else {
        (<any>scheme).active = false;
      }
    });
  }
}